export const ORIGIN = {
  BOOK_DETAILS: 'detalhes'
}
